import intl from "react-intl-universal";

import {ClientInApp} from "../shared/types/SubscriptionTypes";
import {formatDateMonthAsWord, getDaysPassed} from "../utils/date";

import {SUBSCRIPTION_PLANS} from "../checkout/subscription_plans";
import type {CheckoutPeriod} from "../checkout/types";


export const getCurrentPlan = (subscription_plan?: string | null) => {
    if (subscription_plan === 'std') {
        return intl.get('common.subscription.standard').d('Standard');
    } else if (subscription_plan === 'freemium') {
        return intl.get('common.subscription.freemium').d('Freemium');
    } else {
        return intl.get('common.subscription.free_trial').d('Free trial');
    }
}

// freemium or free trial all considered free
export const isFreePlan = (subscription_plan?: string | null) => {
    return subscription_plan !== 'std';
}

// freemium or free trial all considered free
export const isFreemium = (subscription_plan?: string | null) => {
    return subscription_plan === SUBSCRIPTION_PLANS.FREEMIUM;
}

export const isFreeTrial = (client: ClientInApp) => {
    const subscription_plan = client.subscription_plan;
    return subscription_plan === SUBSCRIPTION_PLANS.FREE_TRIAL;
}

export function getDaysLeft(clientRow: ClientInApp): number {
    const startDate = clientRow.createdAt;
    const totalDuration = getTotalDuration(clientRow);
    const today = new Date()
    const daysPassed = getDaysPassed(startDate, today);
    return Math.max(0, totalDuration - daysPassed);
}

export const getTotalDuration = (clientRow: ClientInApp) => {
    const startDate = clientRow.createdAt;
    const endDate = clientRow.subscription_endsAt;
    return endDate ? getDaysPassed(startDate, new Date(endDate)) : 30
}


export const isFreeTrialExpired = (client: ClientInApp) => {
    if (!isFreeTrial(client)) {
        return false;
    }

    let subscriptionEndsAt = client.subscription_endsAt;
    if (!subscriptionEndsAt) {
        const subscriptionEndsAtDate = new Date(client.createdAt);
        subscriptionEndsAtDate.setDate(subscriptionEndsAtDate.getDate() + 30);
        subscriptionEndsAt = subscriptionEndsAtDate.toISOString();
    }

    return subscriptionEndsAt < (new Date()).toISOString()
}

export const getCurrentBillingPeriodText = (client: ClientInApp) => {
    const billing_period = client.subscription_details?.billing_cycle?.interval;
    if (billing_period === 'year') {
        return intl.get('common.subscription.yearly').d('Annual');
    } else if (billing_period === 'month') {
        return intl.get('common.subscription.monthly').d('Monthly');
    } else {
        return '';
    }
}

export const getCurrentCheckoutPeriod = (client: ClientInApp): CheckoutPeriod => {
    if (client?.subscription_status === 'active') {
        const billingInterval = client.subscription_details?.billing_cycle?.interval;
        if (billingInterval === 'year') {
            return 'yearly';
        }
        if (billingInterval === 'month') {
            return 'monthly';
        }
    }

    return 'monthly';
}

export const getNextBillingDate = (client: ClientInApp, currentLocale: string) => {
    const next_billed_at = client.subscription_details?.next_billed_at;
    if (next_billed_at) {
        return formatDateMonthAsWord(currentLocale, new Date(next_billed_at));
    } else {
        return '';
    }
}
